import { IOfferFeaturesSchema } from 'shared/repositories/search-engine/entities/offer_features/OfferFeaturesSchema';

export const prepareFeatures = ({
  objectType,
  totalArea,
  landStatus,
  landArea,
  floorInfo,
  bedroomsCount,
}: IOfferFeaturesSchema): string =>
  [objectType, totalArea, landArea, landStatus, floorInfo, bedroomsCount].filter(Boolean).join(' · ');
